import React from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet } from '@react-pdf/renderer'
import colors from '@settings/styleSettings'

import { Item } from '@generators/pdfComponents/Item'
import { Line } from '@generators/pdfComponents/Line'
import { CharacteristicStatus } from '@generators/pdfComponents/CharacteristicStatus'
import { labelTypes } from '@generators/tresholdConstants'
import { characteristicMask } from '@/util/stringUtil'

const styles = StyleSheet.create({
  characteristic: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 24,
  },
  line: {
    marginBottom: 24,
  },
})

export const HealthCharacteristic = ({ type, value }) => (
  <>
    <View style={styles.characteristic} wrap={false}>
      <Item
        label={labelTypes[type]}
        text={characteristicMask(type, value)}
      />
      <CharacteristicStatus value={value} type={type} />
    </View>
    <Line lineColor={colors.softGray} style={styles.line} />
  </>
)

HealthCharacteristic.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}
